import {
  V2ListCurrencysForAccountApiArg,
  useV2ListCurrencysForAccountQuery,
} from "@generated";
import type { Currency } from "../types";

export interface UseCurrenciesListArgs {
  page?: V2ListCurrencysForAccountApiArg["page"];
  filter?: V2ListCurrencysForAccountApiArg["filter"];
}

export interface CurrenciesListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useCurrenciesList = ({ page, filter }: UseCurrenciesListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListCurrencysForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: Currency[] = (data?.data ?? []).map((currency) => ({
    id: String(currency.id),
    name: currency.attributes?.name ?? "",
    currencyType: currency.attributes?.["currency-type"] ?? "",
    conversionRate: currency.attributes?.["conversion-rate"] ?? null,
    default: !!currency.attributes?.default,
  }));

  const pageMeta: CurrenciesListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useCurrenciesList;
